import {UserTracker} from "../index.js";

const eventDics = {
    "logo": "main:left-menu-logo:click", // 로고
    "project": "main:left-menu-project:click", // 내 프로젝트
    "new-project": "main:left-menu-new-project:click", // 새 프로젝트
    "dashboard": "main:left-menu-dashboard:click", // 대시보드
    "report": "main:left-menu-report:click", // 보고서
    "open": "main:left-menu-open-project:click", // 회사 공개 프로젝트
    "project-more": "main:left-menu-project-more:click", // (프로젝트) 더보기
    "nokeep": "main:left-menu-nokeep:click", // 미분류
    "unread": "main:left-menu-unread:click", // 미확인
    "star": "main:left-menu-star:click", // 즐겨찾기
    "hidden": "main:left-menu-hidden:click", // 숨김
    "more": "main:left-menu-more:click", // 더보기 버튼
    "task": "main:left-menu-task:click", // 업무 모아보기
    "gantt": "main:left-menu-gantt:click", // 간트차트
    "schd": "main:left-menu-schd:click", // 캘린더
    "calendar": "main:left-menu-calendar:click", // 임직원캘린더
    "file": "main:left-menu-file:click", // 파일함
    "bookmark": "main:left-menu-bookmark:click", // 북마크
    "mention": "main:left-menu-mention:click", // 나를 언급
    "my_post": "main:left-menu-my-post:click", // 내 게시물
    "tmpPost": "main:left-menu-temp-post:click", // 임시저장
    "collect-more": "main:left-menu-collect-more:click", // 모아보기
    "recent-project-more": "main:left-menu-recent-project-more:click", // 최근 업데이트
    "label-more": "main:left-menu-label-more:click", // 프로젝트 폴더
    "help-center": "main:left-menu-help-center:click", // ?
    "invite-member": "main:left-menu-invite-member:click", // 직원 초대
    "manager-admin": "main:left-menu-manager-admin:click", // 어드민
    "service-upgrade": "main:left-menu-service-upgrade:click", // 서비스 업그레이드
}

export const LeftMenuTracker = () => {
    const Tracker = Object.create(UserTracker)
    Tracker.track = (eventName) => {
        const event = eventDics[eventName];
        if (!event) return;

        return Tracker.trackAction({event: event, value: null, data: {}});
    }

    return Tracker;
}